/**
 * @module signup 
 *  Apis must need auth details to trigger url - AuthApi
 */

import store from '@/store/store';
import Env from '@/env';
import NormalApis from '@/Components/Controllers/NormalApis';


export default {
    /**
     * Register user, this is old api not in use
     */
    async signup(data) {
      store.dispatch('spinner/setSpinner', true);
      const url = `${Env.loginUrl}/api/v1/users/create`;
      return NormalApis.postApi(url, {
        'api-token': Env.loginApiToken
      }, data)
      .then( async(res) => {
        // store.dispatch('spinner/setSpinner', false);
        // await store.dispatch('userloyalitysubscription/joinUserOnLoyalityProgram', {
        //   user_id: res.data.payload.id,
        //   business_id: store.getters['businessprofile/detail'].id
        // });
        return res;
      })
      .catch(err => {
        // store.dispatch('spinner/setSpinner', false);
        return err;
      });
    },

    /**
     * Get user social profile
     */
     getUserSocialProfile(data) {
      const url = `${Env.loginUrl}/api/v1/users/social_profile`;
      return NormalApis.postApi(url, {
        'api-token': Env.loginApiToken
      }, data)
      .then(res => res)
      .catch(err => err);
    },

    /**
     * Password less signup
     */
    async passwordLessSignup(data) {
      const url = `${Env.loginUrl}/api/v1/users/signup`;
      return NormalApis.postApi(url, {
        'api-token': Env.loginApiToken
      }, data)
      .then( async(res) => {
        // Do not subscribe user on signup only on login and verify email
        // we are not going to signup on loyalty instant only after emai verify we do that
        // await store.dispatch('userloyalitysubscription/joinUserOnLoyalityProgram', {
        //   user_id: res.data.payload.id,
        //   business_id: store.getters['businessprofile/detail'].id
        // });
        return res;
      })
      .catch(err => err);
    },

}